var map = {
	"./about-setting/about-setting.module": [
		"./src/app/about-setting/about-setting.module.ts",
		"about-setting-about-setting-module"
	],
	"./admin/add-coupon-codes/add-coupon-codes.module": [
		"./src/app/admin/add-coupon-codes/add-coupon-codes.module.ts",
		"default~admin-add-coupon-codes-add-coupon-codes-module~admin-coupon-code-modal-coupon-code-modal-module",
		"admin-add-coupon-codes-add-coupon-codes-module"
	],
	"./admin/add-issues-modal/add-issues-modal.module": [
		"./src/app/admin/add-issues-modal/add-issues-modal.module.ts"
	],
	"./admin/add-sub-subcategories/add-sub-subcategories.module": [
		"./src/app/admin/add-sub-subcategories/add-sub-subcategories.module.ts",
		"default~admin-add-sub-subcategories-add-sub-subcategories-module~admin-admin-categories-admin-catego~aaf80eea",
		"admin-add-sub-subcategories-add-sub-subcategories-module"
	],
	"./admin/add-subcategories/add-subcategories.module": [
		"./src/app/admin/add-subcategories/add-subcategories.module.ts"
	],
	"./admin/admin-allusers-details/admin-allusers-details.module": [
		"./src/app/admin/admin-allusers-details/admin-allusers-details.module.ts",
		"admin-admin-allusers-details-admin-allusers-details-module"
	],
	"./admin/admin-allusers/admin-allusers.module": [
		"./src/app/admin/admin-allusers/admin-allusers.module.ts",
		"admin-admin-allusers-admin-allusers-module"
	],
	"./admin/admin-attributes/admin-attributes/admin-attributes.module": [
		"./src/app/admin/admin-attributes/admin-attributes/admin-attributes.module.ts",
		"common",
		"admin-admin-attributes-admin-attributes-admin-attributes-module"
	],
	"./admin/admin-banners/admin-banners.module": [
		"./src/app/admin/admin-banners/admin-banners.module.ts",
		"common",
		"admin-admin-banners-admin-banners-module"
	],
	"./admin/admin-banners/banner-linking-modal/banner-linking-modal.module": [
		"./src/app/admin/admin-banners/banner-linking-modal/banner-linking-modal.module.ts"
	],
	"./admin/admin-banners/banner-settings/banner-settings.module": [
		"./src/app/admin/admin-banners/banner-settings/banner-settings.module.ts",
		"admin-admin-banners-banner-settings-banner-settings-module"
	],
	"./admin/admin-best-sellers/admin-best-sellers.module": [
		"./src/app/admin/admin-best-sellers/admin-best-sellers.module.ts",
		"default~admin-admin-best-sellers-admin-best-sellers-module~admin-best-sellers-modal-best-sellers-modal-module",
		"admin-admin-best-sellers-admin-best-sellers-module"
	],
	"./admin/admin-brands/add-brand/add-brand.module": [
		"./src/app/admin/admin-brands/add-brand/add-brand.module.ts",
		"common",
		"admin-admin-brands-add-brand-add-brand-module"
	],
	"./admin/admin-brands/all-brands/all-brands.module": [
		"./src/app/admin/admin-brands/all-brands/all-brands.module.ts",
		"common",
		"admin-admin-brands-all-brands-all-brands-module"
	],
	"./admin/admin-categories/admin-categories.module": [
		"./src/app/admin/admin-categories/admin-categories.module.ts",
		"default~admin-add-sub-subcategories-add-sub-subcategories-module~admin-admin-categories-admin-catego~aaf80eea",
		"admin-admin-categories-admin-categories-module"
	],
	"./admin/admin-home/admin-chat/admin-chat.module": [
		"./src/app/admin/admin-home/admin-chat/admin-chat.module.ts",
		"default~admin-admin-home-admin-chat-admin-chat-module~chat-bot-chat-bot-module",
		"admin-admin-home-admin-chat-admin-chat-module"
	],
	"./admin/admin-home/admin-home.module": [
		"./src/app/admin/admin-home/admin-home.module.ts",
		"admin-admin-home-admin-home-module"
	],
	"./admin/admin-home/broadcast-msg/broadcast-msg.module": [
		"./src/app/admin/admin-home/broadcast-msg/broadcast-msg.module.ts",
		"admin-admin-home-broadcast-msg-broadcast-msg-module"
	],
	"./admin/admin-home/view-order/view-order.module": [
		"./src/app/admin/admin-home/view-order/view-order.module.ts"
	],
	"./admin/admin-orders/admin-order-popover/admin-order-popover.module": [
		"./src/app/admin/admin-orders/admin-order-popover/admin-order-popover.module.ts"
	],
	"./admin/admin-orders/admin-orders.module": [
		"./src/app/admin/admin-orders/admin-orders.module.ts",
		"default~admin-admin-orders-admin-orders-module~admin-import-export-manager-orders-export-orders-expo~a38f7326",
		"admin-admin-orders-admin-orders-module"
	],
	"./admin/admin-orders/coupons-list/coupons-list.module": [
		"./src/app/admin/admin-orders/coupons-list/coupons-list.module.ts"
	],
	"./admin/admin-orders/create-order/create-order.module": [
		"./src/app/admin/admin-orders/create-order/create-order.module.ts",
		"admin-admin-orders-create-order-create-order-module"
	],
	"./admin/admin-orders/create-order/create-subscription/create-subscription.module": [
		"./src/app/admin/admin-orders/create-order/create-subscription/create-subscription.module.ts"
	],
	"./admin/admin-orders/create-order/product-variant/product-variant.module": [
		"./src/app/admin/admin-orders/create-order/product-variant/product-variant.module.ts"
	],
	"./admin/admin-orders/filters/filters.module": [
		"./src/app/admin/admin-orders/filters/filters.module.ts"
	],
	"./admin/admin-orders/invoices/invoices.module": [
		"./src/app/admin/admin-orders/invoices/invoices.module.ts"
	],
	"./admin/admin-orders/products-to-deliver/products-to-deliver.module": [
		"./src/app/admin/admin-orders/products-to-deliver/products-to-deliver.module.ts",
		"admin-admin-orders-products-to-deliver-products-to-deliver-module"
	],
	"./admin/admin-orders/quotation-chat/quotation-chat.module": [
		"./src/app/admin/admin-orders/quotation-chat/quotation-chat.module.ts"
	],
	"./admin/admin-orders/quotation-edit/quotation-edit.module": [
		"./src/app/admin/admin-orders/quotation-edit/quotation-edit.module.ts"
	],
	"./admin/admin-payment-settings/admin-payment-settings.module": [
		"./src/app/admin/admin-payment-settings/admin-payment-settings.module.ts",
		"admin-admin-payment-settings-admin-payment-settings-module"
	],
	"./admin/admin-payment-settings/payment-gateway-settings/payment-gateway-settings.module": [
		"./src/app/admin/admin-payment-settings/payment-gateway-settings/payment-gateway-settings.module.ts"
	],
	"./admin/admin-products-options/admin-products-options.module": [
		"./src/app/admin/admin-products-options/admin-products-options.module.ts",
		"admin-admin-products-options-admin-products-options-module"
	],
	"./admin/admin-products/admin-products.module": [
		"./src/app/admin/admin-products/admin-products.module.ts",
		"admin-admin-products-admin-products-module"
	],
	"./admin/admin-services/all-services/all-services.module": [
		"./src/app/admin/admin-services/all-services/all-services.module.ts",
		"common",
		"admin-admin-services-all-services-all-services-module"
	],
	"./admin/admin-services/create-service/create-service.module": [
		"./src/app/admin/admin-services/create-service/create-service.module.ts",
		"common",
		"admin-admin-services-create-service-create-service-module"
	],
	"./admin/admin-services/request-complete/request-complete.module": [
		"./src/app/admin/admin-services/request-complete/request-complete.module.ts",
		"admin-admin-services-request-complete-request-complete-module"
	],
	"./admin/admin-services/service-requests/service-requests.module": [
		"./src/app/admin/admin-services/service-requests/service-requests.module.ts",
		"admin-admin-services-service-requests-service-requests-module"
	],
	"./admin/admin-settings/admin-settings.module": [
		"./src/app/admin/admin-settings/admin-settings.module.ts",
		"common",
		"admin-admin-settings-admin-settings-module"
	],
	"./admin/admin-shop/admin-shop.module": [
		"./src/app/admin/admin-shop/admin-shop.module.ts",
		"admin-admin-shop-admin-shop-module"
	],
	"./admin/admin-shop/all-orders/cancelled-reason/cancelled-reason.module": [
		"./src/app/admin/admin-shop/all-orders/cancelled-reason/cancelled-reason.module.ts",
		"admin-admin-shop-all-orders-cancelled-reason-cancelled-reason-module"
	],
	"./admin/admin-shop/all-orders/edit-order/edit-order.module": [
		"./src/app/admin/admin-shop/all-orders/edit-order/edit-order.module.ts"
	],
	"./admin/admin-shop/all-orders/order-details/order-details.module": [
		"./src/app/admin/admin-shop/all-orders/order-details/order-details.module.ts",
		"admin-admin-shop-all-orders-order-details-order-details-module"
	],
	"./admin/admin-shop/categories/categories.module": [
		"./src/app/admin/admin-shop/categories/categories.module.ts",
		"admin-admin-shop-categories-categories-module"
	],
	"./admin/admin-shop/new-product/new-product.module": [
		"./src/app/admin/admin-shop/new-product/new-product.module.ts",
		"default~admin-add-sub-subcategories-add-sub-subcategories-module~admin-admin-categories-admin-catego~aaf80eea",
		"default~admin-admin-shop-new-product-new-product-module~admin-variants-templates-modal-templates-modal-module",
		"common",
		"admin-admin-shop-new-product-new-product-module"
	],
	"./admin/admin-shop/new-product/product-section/product-section.module": [
		"./src/app/admin/admin-shop/new-product/product-section/product-section.module.ts"
	],
	"./admin/admin-terms-settings/admin-terms-settings.module": [
		"./src/app/admin/admin-terms-settings/admin-terms-settings.module.ts",
		"admin-admin-terms-settings-admin-terms-settings-module"
	],
	"./admin/all-feedbacks/all-feedbacks.module": [
		"./src/app/admin/all-feedbacks/all-feedbacks.module.ts",
		"common",
		"admin-all-feedbacks-all-feedbacks-module"
	],
	"./admin/all-support/all-support.module": [
		"./src/app/admin/all-support/all-support.module.ts",
		"admin-all-support-all-support-module"
	],
	"./admin/archived-orders/archived-orders.module": [
		"./src/app/admin/archived-orders/archived-orders.module.ts",
		"admin-archived-orders-archived-orders-module"
	],
	"./admin/best-sellers-modal/best-sellers-modal.module": [
		"./src/app/admin/best-sellers-modal/best-sellers-modal.module.ts",
		"default~admin-admin-best-sellers-admin-best-sellers-module~admin-best-sellers-modal-best-sellers-modal-module",
		"admin-best-sellers-modal-best-sellers-modal-module"
	],
	"./admin/booking-orders/booking-orders.module": [
		"./src/app/admin/booking-orders/booking-orders.module.ts",
		"admin-booking-orders-booking-orders-module"
	],
	"./admin/booking-orders/change-booking-slot/change-booking-slot.module": [
		"./src/app/admin/booking-orders/change-booking-slot/change-booking-slot.module.ts"
	],
	"./admin/booking/booking.module": [
		"./src/app/admin/booking/booking.module.ts",
		"admin-booking-booking-module"
	],
	"./admin/booking/create-booking/create-booking.module": [
		"./src/app/admin/booking/create-booking/create-booking.module.ts",
		"default~admin-add-sub-subcategories-add-sub-subcategories-module~admin-admin-categories-admin-catego~aaf80eea",
		"common",
		"admin-booking-create-booking-create-booking-module"
	],
	"./admin/coupon-code-modal/coupon-code-modal.module": [
		"./src/app/admin/coupon-code-modal/coupon-code-modal.module.ts",
		"default~admin-add-coupon-codes-add-coupon-codes-module~admin-coupon-code-modal-coupon-code-modal-module",
		"admin-coupon-code-modal-coupon-code-modal-module"
	],
	"./admin/coupon-codes/coupon-codes.module": [
		"./src/app/admin/coupon-codes/coupon-codes.module.ts",
		"admin-coupon-codes-coupon-codes-module"
	],
	"./admin/custom-code/custom-code.module": [
		"./src/app/admin/custom-code/custom-code.module.ts",
		"admin-custom-code-custom-code-module"
	],
	"./admin/custom-language/custom-language.module": [
		"./src/app/admin/custom-language/custom-language.module.ts",
		"admin-custom-language-custom-language-module"
	],
	"./admin/dashboard/dashboard.module": [
		"./src/app/admin/dashboard/dashboard.module.ts",
		"admin-dashboard-dashboard-module"
	],
	"./admin/delivery-agent-details/delivery-agent-details.module": [
		"./src/app/admin/delivery-agent-details/delivery-agent-details.module.ts",
		"admin-delivery-agent-details-delivery-agent-details-module"
	],
	"./admin/delivery-settings/area-modal/area-modal.module": [
		"./src/app/admin/delivery-settings/area-modal/area-modal.module.ts"
	],
	"./admin/delivery-settings/delivery-partner-settings/delivery-partner-settings.module": [
		"./src/app/admin/delivery-settings/delivery-partner-settings/delivery-partner-settings.module.ts"
	],
	"./admin/delivery-settings/delivery-settings.module": [
		"./src/app/admin/delivery-settings/delivery-settings.module.ts",
		"admin-delivery-settings-delivery-settings-module"
	],
	"./admin/email-sms/email-sms.module": [
		"./src/app/admin/email-sms/email-sms.module.ts",
		"admin-email-sms-email-sms-module"
	],
	"./admin/feedback-details/feedback-details.module": [
		"./src/app/admin/feedback-details/feedback-details.module.ts",
		"common",
		"admin-feedback-details-feedback-details-module"
	],
	"./admin/filter-settings/add-filter/add-filter.module": [
		"./src/app/admin/filter-settings/add-filter/add-filter.module.ts",
		"admin-filter-settings-add-filter-add-filter-module"
	],
	"./admin/filter-settings/all-filters/all-filters.module": [
		"./src/app/admin/filter-settings/all-filters/all-filters.module.ts",
		"admin-filter-settings-all-filters-all-filters-module"
	],
	"./admin/filter-settings/select-filter/select-filter.module": [
		"./src/app/admin/filter-settings/select-filter/select-filter.module.ts"
	],
	"./admin/food-items/create-food-item/create-food-item.module": [
		"./src/app/admin/food-items/create-food-item/create-food-item.module.ts",
		"default~admin-add-sub-subcategories-add-sub-subcategories-module~admin-admin-categories-admin-catego~aaf80eea",
		"common",
		"admin-food-items-create-food-item-create-food-item-module"
	],
	"./admin/food-items/food-items.module": [
		"./src/app/admin/food-items/food-items.module.ts",
		"admin-food-items-food-items-module"
	],
	"./admin/form-submissions/form-submissions.module": [
		"./src/app/admin/form-submissions/form-submissions.module.ts",
		"admin-form-submissions-form-submissions-module"
	],
	"./admin/forms/forms.module": [
		"./src/app/admin/forms/forms.module.ts",
		"admin-forms-forms-module"
	],
	"./admin/free-products/free-products.module": [
		"./src/app/admin/free-products/free-products.module.ts",
		"admin-free-products-free-products-module"
	],
	"./admin/import-export-manager/csv-import-rules/csv-import-rules.module": [
		"./src/app/admin/import-export-manager/csv-import-rules/csv-import-rules.module.ts"
	],
	"./admin/import-export-manager/delete-bulk-products/delete-bulk-products.module": [
		"./src/app/admin/import-export-manager/delete-bulk-products/delete-bulk-products.module.ts",
		"default~admin-import-export-manager-delete-bulk-products-delete-bulk-products-module~admin-import-ex~8c99e58d",
		"admin-import-export-manager-delete-bulk-products-delete-bulk-products-module"
	],
	"./admin/import-export-manager/import-export-manager.module": [
		"./src/app/admin/import-export-manager/import-export-manager.module.ts",
		"admin-import-export-manager-import-export-manager-module"
	],
	"./admin/import-export-manager/orders/export-orders/export-orders.module": [
		"./src/app/admin/import-export-manager/orders/export-orders/export-orders.module.ts",
		"default~admin-import-export-manager-delete-bulk-products-delete-bulk-products-module~admin-import-ex~8c99e58d",
		"default~admin-admin-orders-admin-orders-module~admin-import-export-manager-orders-export-orders-expo~a38f7326",
		"admin-import-export-manager-orders-export-orders-export-orders-module"
	],
	"./admin/import-export-manager/orders/import-orders/import-orders.module": [
		"./src/app/admin/import-export-manager/orders/import-orders/import-orders.module.ts",
		"default~admin-import-export-manager-delete-bulk-products-delete-bulk-products-module~admin-import-ex~8c99e58d",
		"admin-import-export-manager-orders-import-orders-import-orders-module"
	],
	"./admin/import-export-manager/product-csv-creator/product-csv-creator.module": [
		"./src/app/admin/import-export-manager/product-csv-creator/product-csv-creator.module.ts",
		"default~admin-import-export-manager-delete-bulk-products-delete-bulk-products-module~admin-import-ex~8c99e58d",
		"admin-import-export-manager-product-csv-creator-product-csv-creator-module"
	],
	"./admin/import-export-manager/product-csv-importer/product-csv-importer.module": [
		"./src/app/admin/import-export-manager/product-csv-importer/product-csv-importer.module.ts",
		"default~admin-import-export-manager-delete-bulk-products-delete-bulk-products-module~admin-import-ex~8c99e58d",
		"admin-import-export-manager-product-csv-importer-product-csv-importer-module"
	],
	"./admin/import-export-manager/product-image-exporter/product-image-exporter.module": [
		"./src/app/admin/import-export-manager/product-image-exporter/product-image-exporter.module.ts",
		"admin-import-export-manager-product-image-exporter-product-image-exporter-module"
	],
	"./admin/import-export-manager/product-image-importer/product-image-importer.module": [
		"./src/app/admin/import-export-manager/product-image-importer/product-image-importer.module.ts",
		"admin-import-export-manager-product-image-importer-product-image-importer-module"
	],
	"./admin/import-export-manager/users/export-users/export-users.module": [
		"./src/app/admin/import-export-manager/users/export-users/export-users.module.ts",
		"default~admin-import-export-manager-delete-bulk-products-delete-bulk-products-module~admin-import-ex~8c99e58d",
		"admin-import-export-manager-users-export-users-export-users-module"
	],
	"./admin/import-export-manager/users/import-users/import-users.module": [
		"./src/app/admin/import-export-manager/users/import-users/import-users.module.ts",
		"default~admin-import-export-manager-delete-bulk-products-delete-bulk-products-module~admin-import-ex~8c99e58d",
		"admin-import-export-manager-users-import-users-import-users-module"
	],
	"./admin/import-products/import-products.module": [
		"./src/app/admin/import-products/import-products.module.ts",
		"admin-import-products-import-products-module"
	],
	"./admin/language-settings/language-add/language-add.module": [
		"./src/app/admin/language-settings/language-add/language-add.module.ts",
		"admin-language-settings-language-add-language-add-module"
	],
	"./admin/language-settings/language-current/language-current.module": [
		"./src/app/admin/language-settings/language-current/language-current.module.ts",
		"admin-language-settings-language-current-language-current-module"
	],
	"./admin/manage-shipment/manage-shipment.module": [
		"./src/app/admin/manage-shipment/manage-shipment.module.ts",
		"admin-manage-shipment-manage-shipment-module"
	],
	"./admin/managers/manager-edit/manager-edit.module": [
		"./src/app/admin/managers/manager-edit/manager-edit.module.ts",
		"admin-managers-manager-edit-manager-edit-module"
	],
	"./admin/managers/managers.module": [
		"./src/app/admin/managers/managers.module.ts",
		"admin-managers-managers-module"
	],
	"./admin/membership-settings/membership-settings.module": [
		"./src/app/admin/membership-settings/membership-settings.module.ts",
		"admin-membership-settings-membership-settings-module"
	],
	"./admin/multi-countries/multi-countries.module": [
		"./src/app/admin/multi-countries/multi-countries.module.ts",
		"admin-multi-countries-multi-countries-module"
	],
	"./admin/multi-region/multi-region-add/multi-region-add.module": [
		"./src/app/admin/multi-region/multi-region-add/multi-region-add.module.ts",
		"admin-multi-region-multi-region-add-multi-region-add-module"
	],
	"./admin/multi-region/multi-region-all/multi-region-all.module": [
		"./src/app/admin/multi-region/multi-region-all/multi-region-all.module.ts",
		"admin-multi-region-multi-region-all-multi-region-all-module"
	],
	"./admin/multi-vendor/multi-vendor-add/multi-vendor-add.module": [
		"./src/app/admin/multi-vendor/multi-vendor-add/multi-vendor-add.module.ts",
		"default~admin-add-sub-subcategories-add-sub-subcategories-module~admin-admin-categories-admin-catego~aaf80eea",
		"admin-multi-vendor-multi-vendor-add-multi-vendor-add-module"
	],
	"./admin/multi-vendor/multi-vendor-all/add-vendor-modal/add-vendor-modal.module": [
		"./src/app/admin/multi-vendor/multi-vendor-all/add-vendor-modal/add-vendor-modal.module.ts"
	],
	"./admin/multi-vendor/multi-vendor-all/multi-vendor-all.module": [
		"./src/app/admin/multi-vendor/multi-vendor-all/multi-vendor-all.module.ts",
		"admin-multi-vendor-multi-vendor-all-multi-vendor-all-module"
	],
	"./admin/multi-vendor/vendor-products/vendor-products.module": [
		"./src/app/admin/multi-vendor/vendor-products/vendor-products.module.ts"
	],
	"./admin/offer-create/offer-create.module": [
		"./src/app/admin/offer-create/offer-create.module.ts",
		"common",
		"admin-offer-create-offer-create-module"
	],
	"./admin/offer-settings/offer-settings.module": [
		"./src/app/admin/offer-settings/offer-settings.module.ts",
		"common",
		"admin-offer-settings-offer-settings-module"
	],
	"./admin/pickup-drop/pickup-drop.module": [
		"./src/app/admin/pickup-drop/pickup-drop.module.ts",
		"default~admin-admin-orders-admin-orders-module~admin-import-export-manager-orders-export-orders-expo~a38f7326",
		"admin-pickup-drop-pickup-drop-module"
	],
	"./admin/plan-payments/add-ons/add-ons.module": [
		"./src/app/admin/plan-payments/add-ons/add-ons.module.ts"
	],
	"./admin/plan-payments/complete-payment/complete-payment.module": [
		"./src/app/admin/plan-payments/complete-payment/complete-payment.module.ts",
		"admin-plan-payments-complete-payment-complete-payment-module"
	],
	"./admin/plan-payments/plan-payments.module": [
		"./src/app/admin/plan-payments/plan-payments.module.ts",
		"admin-plan-payments-plan-payments-module"
	],
	"./admin/price-requests/price-requests.module": [
		"./src/app/admin/price-requests/price-requests.module.ts",
		"common",
		"admin-price-requests-price-requests-module"
	],
	"./admin/product-addons/product-addons.module": [
		"./src/app/admin/product-addons/product-addons.module.ts",
		"admin-product-addons-product-addons-module"
	],
	"./admin/product-settings/product-settings.module": [
		"./src/app/admin/product-settings/product-settings.module.ts",
		"admin-product-settings-product-settings-module"
	],
	"./admin/products-modal/products-modal.module": [
		"./src/app/admin/products-modal/products-modal.module.ts"
	],
	"./admin/promo-popup-settings/promo-popup-settings.module": [
		"./src/app/admin/promo-popup-settings/promo-popup-settings.module.ts",
		"admin-promo-popup-settings-promo-popup-settings-module"
	],
	"./admin/rating-approval/rating-approval.module": [
		"./src/app/admin/rating-approval/rating-approval.module.ts",
		"admin-rating-approval-rating-approval-module"
	],
	"./admin/referral-settings/referral-settings.module": [
		"./src/app/admin/referral-settings/referral-settings.module.ts",
		"admin-referral-settings-referral-settings-module"
	],
	"./admin/resale-order/resale-order.module": [
		"./src/app/admin/resale-order/resale-order.module.ts",
		"admin-resale-order-resale-order-module"
	],
	"./admin/retailers/retailers.module": [
		"./src/app/admin/retailers/retailers.module.ts",
		"admin-retailers-retailers-module"
	],
	"./admin/sample-homepage/sample-homepage.module": [
		"./src/app/admin/sample-homepage/sample-homepage.module.ts",
		"admin-sample-homepage-sample-homepage-module"
	],
	"./admin/select-categories/select-categories.module": [
		"./src/app/admin/select-categories/select-categories.module.ts"
	],
	"./admin/showcase/create-showcase/create-showcase.module": [
		"./src/app/admin/showcase/create-showcase/create-showcase.module.ts",
		"default~admin-add-sub-subcategories-add-sub-subcategories-module~admin-admin-categories-admin-catego~aaf80eea",
		"common",
		"admin-showcase-create-showcase-create-showcase-module"
	],
	"./admin/showcase/showcase.module": [
		"./src/app/admin/showcase/showcase.module.ts",
		"admin-showcase-showcase-module"
	],
	"./admin/subscription-calendar/subscription-calendar.module": [
		"./src/app/admin/subscription-calendar/subscription-calendar.module.ts"
	],
	"./admin/subscriptions/subscriptions.module": [
		"./src/app/admin/subscriptions/subscriptions.module.ts",
		"admin-subscriptions-subscriptions-module"
	],
	"./admin/support/support.module": [
		"./src/app/admin/support/support.module.ts",
		"admin-support-support-module"
	],
	"./admin/user-cart-details-modal/user-cart-details-modal.module": [
		"./src/app/admin/user-cart-details-modal/user-cart-details-modal.module.ts"
	],
	"./admin/user-groups/user-groups-modal/user-groups-modal.module": [
		"./src/app/admin/user-groups/user-groups-modal/user-groups-modal.module.ts"
	],
	"./admin/user-groups/user-groups.module": [
		"./src/app/admin/user-groups/user-groups.module.ts",
		"admin-user-groups-user-groups-module"
	],
	"./admin/users-cart/users-cart.module": [
		"./src/app/admin/users-cart/users-cart.module.ts",
		"admin-users-cart-users-cart-module"
	],
	"./admin/users-modal/users-modal.module": [
		"./src/app/admin/users-modal/users-modal.module.ts"
	],
	"./admin/variants/colors-modal/colors-modal.module": [
		"./src/app/admin/variants/colors-modal/colors-modal.module.ts"
	],
	"./admin/variants/templates-modal/templates-modal.module": [
		"./src/app/admin/variants/templates-modal/templates-modal.module.ts",
		"default~admin-admin-shop-new-product-new-product-module~admin-variants-templates-modal-templates-modal-module",
		"admin-variants-templates-modal-templates-modal-module"
	],
	"./admin/vendor-settings/vendor-settings.module": [
		"./src/app/admin/vendor-settings/vendor-settings.module.ts",
		"admin-vendor-settings-vendor-settings-module"
	],
	"./admin/view-issues-modal/view-issues-modal.module": [
		"./src/app/admin/view-issues-modal/view-issues-modal.module.ts"
	],
	"./admin/vouchers/create-voucher/create-voucher.module": [
		"./src/app/admin/vouchers/create-voucher/create-voucher.module.ts",
		"default~admin-add-sub-subcategories-add-sub-subcategories-module~admin-admin-categories-admin-catego~aaf80eea",
		"common",
		"admin-vouchers-create-voucher-create-voucher-module"
	],
	"./admin/vouchers/vouchers.module": [
		"./src/app/admin/vouchers/vouchers.module.ts",
		"admin-vouchers-vouchers-module"
	],
	"./admin/wallet-settings/wallet-settings.module": [
		"./src/app/admin/wallet-settings/wallet-settings.module.ts",
		"admin-wallet-settings-wallet-settings-module"
	],
	"./admin/whatsapp/add-whatsapp-template/add-whatsapp-template.module": [
		"./src/app/admin/whatsapp/add-whatsapp-template/add-whatsapp-template.module.ts",
		"admin-whatsapp-add-whatsapp-template-add-whatsapp-template-module"
	],
	"./admin/whatsapp/whatsapp-broadcast/whatsapp-broadcast.module": [
		"./src/app/admin/whatsapp/whatsapp-broadcast/whatsapp-broadcast.module.ts",
		"admin-whatsapp-whatsapp-broadcast-whatsapp-broadcast-module"
	],
	"./admin/whatsapp/whatsapp-list-services/whatsapp-list-services.module": [
		"./src/app/admin/whatsapp/whatsapp-list-services/whatsapp-list-services.module.ts",
		"admin-whatsapp-whatsapp-list-services-whatsapp-list-services-module"
	],
	"./admin/whatsapp/whatsapp-list/whatsapp-list.module": [
		"./src/app/admin/whatsapp/whatsapp-list/whatsapp-list.module.ts",
		"admin-whatsapp-whatsapp-list-whatsapp-list-module"
	],
	"./admin/whatsapp/whatsapp-menu/whatsapp-menu.module": [
		"./src/app/admin/whatsapp/whatsapp-menu/whatsapp-menu.module.ts",
		"admin-whatsapp-whatsapp-menu-whatsapp-menu-module"
	],
	"./admin/whatsapp/whatsapp-settings/whatsapp-settings.module": [
		"./src/app/admin/whatsapp/whatsapp-settings/whatsapp-settings.module.ts",
		"admin-whatsapp-whatsapp-settings-whatsapp-settings-module"
	],
	"./all-offers/all-offers.module": [
		"./src/app/all-offers/all-offers.module.ts",
		"common",
		"all-offers-all-offers-module"
	],
	"./analytics/views-count-popover/views-count-popover.module": [
		"./src/app/analytics/views-count-popover/views-count-popover.module.ts"
	],
	"./auto-confirm-payment/auto-confirm-payment.module": [
		"./src/app/auto-confirm-payment/auto-confirm-payment.module.ts",
		"auto-confirm-payment-auto-confirm-payment-module"
	],
	"./buynow-pricelist-modal/buynow-pricelist-modal.module": [
		"./src/app/buynow-pricelist-modal/buynow-pricelist-modal.module.ts",
		"default~buynow-pricelist-modal-buynow-pricelist-modal-module~product-details-product-details-module",
		"buynow-pricelist-modal-buynow-pricelist-modal-module"
	],
	"./chat-bot/chat-bot.module": [
		"./src/app/chat-bot/chat-bot.module.ts",
		"default~admin-admin-home-admin-chat-admin-chat-module~chat-bot-chat-bot-module",
		"chat-bot-chat-bot-module"
	],
	"./contact-settings/contact-settings.module": [
		"./src/app/contact-settings/contact-settings.module.ts",
		"contact-settings-contact-settings-module"
	],
	"./delivery/delivery-navigation/delivery-navigation.module": [
		"./src/app/delivery/delivery-navigation/delivery-navigation.module.ts",
		"delivery-delivery-navigation-delivery-navigation-module"
	],
	"./delivery/delivery-order-details/delivery-order-details.module": [
		"./src/app/delivery/delivery-order-details/delivery-order-details.module.ts",
		"delivery-delivery-order-details-delivery-order-details-module"
	],
	"./delivery/delivery-orders/delivery-orders.module": [
		"./src/app/delivery/delivery-orders/delivery-orders.module.ts",
		"delivery-delivery-orders-delivery-orders-module"
	],
	"./faq/faq.module": [
		"./src/app/faq/faq.module.ts",
		"faq-faq-module"
	],
	"./home/verify-otp/verify-otp.module": [
		"./src/app/home/verify-otp/verify-otp.module.ts",
		"home-verify-otp-verify-otp-module"
	],
	"./home/your-identity/your-identity.module": [
		"./src/app/home/your-identity/your-identity.module.ts",
		"home-your-identity-your-identity-module"
	],
	"./homepage/homepage.module": [
		"./src/app/homepage/homepage.module.ts",
		"homepage-homepage-module"
	],
	"./image-modal/image-modal.module": [
		"./src/app/image-modal/image-modal.module.ts"
	],
	"./integrations/integration-settings/integration-settings.module": [
		"./src/app/integrations/integration-settings/integration-settings.module.ts"
	],
	"./integrations/integrations.module": [
		"./src/app/integrations/integrations.module.ts",
		"integrations-integrations-module"
	],
	"./location-map/location-map.module": [
		"./src/app/location-map/location-map.module.ts",
		"location-map-location-map-module"
	],
	"./manage-roles/manage-roles.module": [
		"./src/app/manage-roles/manage-roles.module.ts",
		"manage-roles-manage-roles-module"
	],
	"./new-address/new-address.module": [
		"./src/app/new-address/new-address.module.ts",
		"new-address-new-address-module"
	],
	"./no-user-access/no-user-access.module": [
		"./src/app/no-user-access/no-user-access.module.ts",
		"no-user-access-no-user-access-module"
	],
	"./order-payment/order-payment.module": [
		"./src/app/order-payment/order-payment.module.ts",
		"order-payment-order-payment-module"
	],
	"./order-summary/order-summary.module": [
		"./src/app/order-summary/order-summary.module.ts",
		"order-summary-order-summary-module"
	],
	"./pages/blogs-setting/blogs-setting.module": [
		"./src/app/pages/blogs-setting/blogs-setting.module.ts",
		"pages-blogs-setting-blogs-setting-module"
	],
	"./pages/homepage-setting/edit-widget/edit-widget.module": [
		"./src/app/pages/homepage-setting/edit-widget/edit-widget.module.ts"
	],
	"./pages/homepage-setting/homepage-setting.module": [
		"./src/app/pages/homepage-setting/homepage-setting.module.ts",
		"pages-homepage-setting-homepage-setting-module"
	],
	"./pages/homepage-setting/select-widget-modal/select-widget-modal.module": [
		"./src/app/pages/homepage-setting/select-widget-modal/select-widget-modal.module.ts"
	],
	"./pages/pages-setting/pages-setting.module": [
		"./src/app/pages/pages-setting/pages-setting.module.ts",
		"pages-pages-setting-pages-setting-module"
	],
	"./pages/widgets/edit-brands/edit-brands.module": [
		"./src/app/pages/widgets/edit-brands/edit-brands.module.ts",
		"pages-widgets-edit-brands-edit-brands-module"
	],
	"./pages/widgets/edit-categories/edit-categories.module": [
		"./src/app/pages/widgets/edit-categories/edit-categories.module.ts",
		"pages-widgets-edit-categories-edit-categories-module"
	],
	"./pages/widgets/edit-document/edit-document.module": [
		"./src/app/pages/widgets/edit-document/edit-document.module.ts",
		"pages-widgets-edit-document-edit-document-module"
	],
	"./pages/widgets/edit-form/add-input/add-input.module": [
		"./src/app/pages/widgets/edit-form/add-input/add-input.module.ts"
	],
	"./pages/widgets/edit-form/edit-form.module": [
		"./src/app/pages/widgets/edit-form/edit-form.module.ts",
		"pages-widgets-edit-form-edit-form-module"
	],
	"./pages/widgets/edit-form/preview-form/preview-form.module": [
		"./src/app/pages/widgets/edit-form/preview-form/preview-form.module.ts"
	],
	"./pages/widgets/edit-services/edit-services.module": [
		"./src/app/pages/widgets/edit-services/edit-services.module.ts",
		"pages-widgets-edit-services-edit-services-module"
	],
	"./pages/widgets/edit-vendors/edit-vendors.module": [
		"./src/app/pages/widgets/edit-vendors/edit-vendors.module.ts",
		"pages-widgets-edit-vendors-edit-vendors-module"
	],
	"./pages/widgets/image-block/edit-image-block/edit-image-block.module": [
		"./src/app/pages/widgets/image-block/edit-image-block/edit-image-block.module.ts",
		"pages-widgets-image-block-edit-image-block-edit-image-block-module"
	],
	"./pages/widgets/image-block/image-block-list/image-block-list.module": [
		"./src/app/pages/widgets/image-block/image-block-list/image-block-list.module.ts",
		"pages-widgets-image-block-image-block-list-image-block-list-module"
	],
	"./pages/widgets/product-carousel/edit-product-carousel/edit-product-carousel.module": [
		"./src/app/pages/widgets/product-carousel/edit-product-carousel/edit-product-carousel.module.ts",
		"pages-widgets-product-carousel-edit-product-carousel-edit-product-carousel-module"
	],
	"./pages/widgets/product-carousel/product-carousel-list/product-carousel-list.module": [
		"./src/app/pages/widgets/product-carousel/product-carousel-list/product-carousel-list.module.ts",
		"pages-widgets-product-carousel-product-carousel-list-product-carousel-list-module"
	],
	"./pages/widgets/product-list-modal/product-list-modal.module": [
		"./src/app/pages/widgets/product-list-modal/product-list-modal.module.ts"
	],
	"./pages/widgets/text-block/edit-text-block/edit-text-block.module": [
		"./src/app/pages/widgets/text-block/edit-text-block/edit-text-block.module.ts",
		"pages-widgets-text-block-edit-text-block-edit-text-block-module"
	],
	"./pages/widgets/text-block/text-block-list/text-block-list.module": [
		"./src/app/pages/widgets/text-block/text-block-list/text-block-list.module.ts",
		"pages-widgets-text-block-text-block-list-text-block-list-module"
	],
	"./pages/widgets/video-block/edit-video-block/edit-video-block.module": [
		"./src/app/pages/widgets/video-block/edit-video-block/edit-video-block.module.ts",
		"pages-widgets-video-block-edit-video-block-edit-video-block-module"
	],
	"./pages/widgets/video-block/video-block-list/video-block-list.module": [
		"./src/app/pages/widgets/video-block/video-block-list/video-block-list.module.ts",
		"pages-widgets-video-block-video-block-list-video-block-list-module"
	],
	"./pages/widgets/widget-banner-slider/banner-slider-widgets-list/banner-slider-widgets-list.module": [
		"./src/app/pages/widgets/widget-banner-slider/banner-slider-widgets-list/banner-slider-widgets-list.module.ts",
		"pages-widgets-widget-banner-slider-banner-slider-widgets-list-banner-slider-widgets-list-module"
	],
	"./pages/widgets/widget-banner-slider/banners-list/banners-list.module": [
		"./src/app/pages/widgets/widget-banner-slider/banners-list/banners-list.module.ts",
		"pages-widgets-widget-banner-slider-banners-list-banners-list-module"
	],
	"./pages/widgets/widget-banner-slider/edit-banner/edit-banner.module": [
		"./src/app/pages/widgets/widget-banner-slider/edit-banner/edit-banner.module.ts",
		"pages-widgets-widget-banner-slider-edit-banner-edit-banner-module"
	],
	"./pages/widgets/widget-banner-slider/edit-slide/edit-slide.module": [
		"./src/app/pages/widgets/widget-banner-slider/edit-slide/edit-slide.module.ts",
		"pages-widgets-widget-banner-slider-edit-slide-edit-slide-module"
	],
	"./pages/widgets/widget-image-banner/edit-image-banner/edit-image-banner.module": [
		"./src/app/pages/widgets/widget-image-banner/edit-image-banner/edit-image-banner.module.ts",
		"pages-widgets-widget-image-banner-edit-image-banner-edit-image-banner-module"
	],
	"./pages/widgets/widget-image-banner/image-banners-list/image-banners-list.module": [
		"./src/app/pages/widgets/widget-image-banner/image-banners-list/image-banners-list.module.ts",
		"pages-widgets-widget-image-banner-image-banners-list-image-banners-list-module"
	],
	"./pages/widgets/widget-type-modal/widget-type-modal.module": [
		"./src/app/pages/widgets/widget-type-modal/widget-type-modal.module.ts",
		"pages-widgets-widget-type-modal-widget-type-modal-module"
	],
	"./pages/widgets/widgets-banner-slider/widgets-banner-slider.module": [
		"./src/app/pages/widgets/widgets-banner-slider/widgets-banner-slider.module.ts",
		"pages-widgets-widgets-banner-slider-widgets-banner-slider-module"
	],
	"./pages/widgets/widgets-list/widgets-list.module": [
		"./src/app/pages/widgets/widgets-list/widgets-list.module.ts",
		"pages-widgets-widgets-list-widgets-list-module"
	],
	"./pincodes-modal/pincodes-modal.module": [
		"./src/app/pincodes-modal/pincodes-modal.module.ts"
	],
	"./pricelist-modal/pricelist-modal.module": [
		"./src/app/pricelist-modal/pricelist-modal.module.ts"
	],
	"./product-details/product-details.module": [
		"./src/app/product-details/product-details.module.ts",
		"default~buynow-pricelist-modal-buynow-pricelist-modal-module~product-details-product-details-module",
		"product-details-product-details-module"
	],
	"./product-reviews/product-review/product-review.module": [
		"./src/app/product-reviews/product-review/product-review.module.ts"
	],
	"./product-reviews/product-reviews.module": [
		"./src/app/product-reviews/product-reviews.module.ts",
		"product-reviews-product-reviews-module"
	],
	"./profile/profile.module": [
		"./src/app/profile/profile.module.ts",
		"profile-profile-module"
	],
	"./reports/area-report/area-report.module": [
		"./src/app/reports/area-report/area-report.module.ts",
		"reports-area-report-area-report-module"
	],
	"./reports/brands-report/brands-report.module": [
		"./src/app/reports/brands-report/brands-report.module.ts",
		"common",
		"reports-brands-report-brands-report-module"
	],
	"./reports/category-report/category-report.module": [
		"./src/app/reports/category-report/category-report.module.ts",
		"common",
		"reports-category-report-category-report-module"
	],
	"./reports/coupon-report/coupon-report.module": [
		"./src/app/reports/coupon-report/coupon-report.module.ts",
		"reports-coupon-report-coupon-report-module"
	],
	"./reports/products-report/products-report.module": [
		"./src/app/reports/products-report/products-report.module.ts",
		"reports-products-report-products-report-module"
	],
	"./reports/referral-report/referral-report.module": [
		"./src/app/reports/referral-report/referral-report.module.ts",
		"reports-referral-report-referral-report-module"
	],
	"./reports/referral-report/referred-users-modal/referred-users-modal.module": [
		"./src/app/reports/referral-report/referred-users-modal/referred-users-modal.module.ts"
	],
	"./reports/sales-report/sales-report.module": [
		"./src/app/reports/sales-report/sales-report.module.ts",
		"reports-sales-report-sales-report-module"
	],
	"./reports/sales-reports/sales-reports.module": [
		"./src/app/reports/sales-reports/sales-reports.module.ts",
		"reports-sales-reports-sales-reports-module"
	],
	"./reports/services-report/services-report.module": [
		"./src/app/reports/services-report/services-report.module.ts",
		"common",
		"reports-services-report-services-report-module"
	],
	"./reports/tax-report/tax-report.module": [
		"./src/app/reports/tax-report/tax-report.module.ts",
		"reports-tax-report-tax-report-module"
	],
	"./reports/users-report/users-report.module": [
		"./src/app/reports/users-report/users-report.module.ts",
		"reports-users-report-users-report-module"
	],
	"./reports/vendor-report/vendor-report.module": [
		"./src/app/reports/vendor-report/vendor-report.module.ts",
		"reports-vendor-report-vendor-report-module"
	],
	"./search-items/search-items.module": [
		"./src/app/search-items/search-items.module.ts",
		"search-items-search-items-module"
	],
	"./select-address/select-address.module": [
		"./src/app/select-address/select-address.module.ts",
		"select-address-select-address-module"
	],
	"./shop/shop-categories/shop-categories.module": [
		"./src/app/shop/shop-categories/shop-categories.module.ts",
		"common",
		"shop-shop-categories-shop-categories-module"
	],
	"./shop/shop-subcategories/shop-subcategories.module": [
		"./src/app/shop/shop-subcategories/shop-subcategories.module.ts",
		"shop-shop-subcategories-shop-subcategories-module"
	],
	"./shop/shop.module": [
		"./src/app/shop/shop.module.ts",
		"shop-shop-module"
	],
	"./sidemenu/sidemenu.module": [
		"./src/app/sidemenu/sidemenu.module.ts",
		"sidemenu-sidemenu-module"
	],
	"./states-modal/states-modal.module": [
		"./src/app/states-modal/states-modal.module.ts"
	],
	"./terms-conditions/terms-conditions.module": [
		"./src/app/terms-conditions/terms-conditions.module.ts",
		"terms-conditions-terms-conditions-module"
	],
	"./terms-privacy/terms-privacy.module": [
		"./src/app/terms-privacy/terms-privacy.module.ts",
		"terms-privacy-terms-privacy-module"
	],
	"./user-addresses/user-addresses.module": [
		"./src/app/user-addresses/user-addresses.module.ts",
		"user-addresses-user-addresses-module"
	],
	"./user-cart/user-cart.module": [
		"./src/app/user-cart/user-cart.module.ts",
		"user-cart-user-cart-module"
	],
	"./user-order-details/user-order-details.module": [
		"./src/app/user-order-details/user-order-details.module.ts",
		"user-order-details-user-order-details-module"
	],
	"./user-order-history/user-order-history.module": [
		"./src/app/user-order-history/user-order-history.module.ts",
		"user-order-history-user-order-history-module"
	],
	"./vendor-membership/buy-vendor-membership/buy-vendor-membership.module": [
		"./src/app/vendor-membership/buy-vendor-membership/buy-vendor-membership.module.ts",
		"vendor-membership-buy-vendor-membership-buy-vendor-membership-module"
	],
	"./vendor-membership/vendor-membership.module": [
		"./src/app/vendor-membership/vendor-membership.module.ts",
		"vendor-membership-vendor-membership-module"
	],
	"./vendor-order-details/vendor-order-details.module": [
		"./src/app/vendor-order-details/vendor-order-details.module.ts"
	],
	"./vendor-orders/vendor-orders.module": [
		"./src/app/vendor-orders/vendor-orders.module.ts",
		"vendor-orders-vendor-orders-module"
	],
	"./vendor-registration/vendor-registration.module": [
		"./src/app/vendor-registration/vendor-registration.module.ts",
		"vendor-registration-vendor-registration-module"
	],
	"./vendor-registration/vendor-request-modal/vendor-request-modal.module": [
		"./src/app/vendor-registration/vendor-request-modal/vendor-request-modal.module.ts"
	],
	"./vendor-settings/vendor-settings.module": [
		"./src/app/vendor-settings/vendor-settings.module.ts",
		"vendor-settings-vendor-settings-module"
	],
	"./video-help/video-help/video-help.module": [
		"./src/app/video-help/video-help/video-help.module.ts"
	],
	"./website-seo/website-seo.module": [
		"./src/app/website-seo/website-seo.module.ts",
		"website-seo-website-seo-module"
	],
	"./whatsapp-promotions/whatsapp-promotions.module": [
		"./src/app/whatsapp-promotions/whatsapp-promotions.module.ts",
		"whatsapp-promotions-whatsapp-promotions-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;